import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Configuracao from '../../util/Configuracao';

dayjs.extend(customParseFormat);

/**
 * @classdesc Agrupa as regras semânticas relacionadas aos dados da sessão.
 */
export default class SessaoFormatter {
    static FORMATO_DATAHORA_ENTRADA = Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO;

    static formatoSaida(exibirHora) {
        return exibirHora ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';
    }

    /**
     * Formata a data da sessão de julgamento.
     *
     * @param {object} prazos - Objeto contendo os prazos da sessão.
     * @param {boolean} exibirHora - Se deve incluir a hora na formatação.
     * @returns {string} Informação com a data de julgamento da sessão.
     */
    static formatarDataSessaoPresencial(prazos, exibirHora = true) {
        if (prazos?.dataInicioSessaoPresencial) {
            const dataObj = dayjs(prazos.dataInicioSessaoPresencial, this.FORMATO_DATAHORA_ENTRADA);
            return dataObj.format(this.formatoSaida(exibirHora));
        }

        return '';
    }

    /**
     * Formata o período de julgamento virtual.
     *
     * @param {object} prazos - Objeto contendo os prazos da sessão.
     * @param {boolean} exibirHora - Se deve incluir a hora na formatação.
     * @returns {string} Informação com período de julgamento virtual da sessão.
     */
    static formatarPeriodoJulgamentoVirtual(prazos, exibirHora = true) {
        if (prazos?.dataInicioVotacaoVirtual && prazos?.dataFimVotacaoVirtual) {
            const dataInicioString = dayjs(prazos.dataInicioVotacaoVirtual, this.FORMATO_DATAHORA_ENTRADA).format(
                this.formatoSaida(exibirHora)
            );

            const dataFim = dayjs(prazos.dataFimVotacaoVirtual, this.FORMATO_DATAHORA_ENTRADA);
            let dataFimString;

            if (!exibirHora && dataFim.hour() === 0 && dataFim.minute() === 0) {
                dataFimString = dataFim.subtract(1, 'day').format(this.formatoSaida(exibirHora));
            } else {
                dataFimString = dataFim.format(this.formatoSaida(exibirHora));
            }

            return `${dataInicioString} a ${dataFimString}`;
        }

        return '';
    }

    /**
     * Formata a data da sessão de julgamento.
     *
     * @param {string} codigoMeioJulgamentoSessao - Código do meio de julgamento da sessão.
     * @param {object} prazos - Objeto contendo os prazos da sessão.
     * @param {boolean} exibirHora - Se deve incluir a hora na formatação.
     * @returns {string} Informação com a data de julgamento da sessão.
     */
    static formatarDataSessao(codigoMeioJulgamentoSessao, prazos, exibirHora = true) {
        if (codigoMeioJulgamentoSessao === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo) {
            return this.formatarPeriodoJulgamentoVirtual(prazos, exibirHora);
        }

        if (prazos.temPrazoDeVotacaoVirtual) {
            return `${this.formatarDataSessaoPresencial(prazos, exibirHora)} (${this.formatarPeriodoJulgamentoVirtual(prazos, false)})`;
        } else {
            return this.formatarDataSessaoPresencial(prazos, exibirHora);
        }
    }
}
